import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

// Custom preset using colors from theme.css. semantic.primary overrides Aura emerald.
export const customPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: 'var(--color-primary-50)',
      100: 'var(--color-primary-100)',
      200: 'var(--color-primary-200)',
      300: 'var(--color-primary-300)',
      400: 'var(--color-primary-400)',
      500: 'var(--color-primary-500)',
      600: 'var(--color-primary-600)',
      700: 'var(--color-primary-800)',
      800: 'var(--color-primary-800)',
      900: 'var(--color-primary-900)',
      950: 'var(--color-primary-950)',
    },
  },

  components: {

    // Button Components
    button: {
      paddingY: '10px!important',
      paddingX: '26px!important',
      borderRadius: '10px!important',
      text: {
        primary: {
          hoverBackground: 'var(--color-primary-50)!important',
          activeBackground: 'var(--color-primary-100)!important',
          color: 'var(--color-primary-600)!important',
        },
      },

      primary: {
        background: 'var(--color-primary-950)!important',
        borderColor: 'var(--color-primary-950)!important',
        color: 'var(--color-grey-0)!important',

        hoverBackground: 'var(--color-primary-900)!important',
        hoverBorderColor: 'var(--color-primary-900)!important',
        hoverColor: 'var(--color-grey-0)!important',

        activeBackground: 'var(--color-primary-950)!important',
        activeBorderColor: 'var(--color-primary-950)!important',
        activeColor: 'var(--color-grey-0)!important',
      },
      secondary: {
        background: 'var(--color-grey-50)!important',
        borderColor: 'var(--color-grey-100)!important',
        color: 'var(--color-grey-950)!important',

        hoverBackground: 'var(--color-grey-100)!important',
        hoverBorderColor: 'var(--color-grey-200)!important',
        hoverColor: 'var(--color-grey-950)!important',

        activeBackground: 'var(--color-grey-50)!important',
        activeBorderColor: 'var(--color-grey-100)!important',
        activeColor: 'var(--color-grey-950)!important',
      },
      contrast: {
        background: 'var(--color-grey-950)!important',
        borderColor: 'var(--color-grey-950)!important',
        color: 'var(--color-grey-0)!important',

        hoverBackground: 'var(--color-grey-900)!important',
        hoverBorderColor: 'var(--color-grey-900)!important',
        hoverColor: 'var(--color-grey-0)!important',

        activeBackground: 'var(--color-grey-950)!important ',
        activeBorderColor: 'var(--color-grey-950)!important ',
        activeColor: 'var(--color-grey-0)!important ',
      },

      lg: {
        paddingY: '10px!important',
        paddingX: '26px!important',
        fontSize: '14px!important',
      },
    },

    popover: {
      padding: '0px!important',
      gutter: '0px!important',
      borderColor: 'var(--color-grey-50)!important',
      shadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.08)!important',
      content: {
        padding: '0px!important',
      },
    },

    listbox: {
      borderColor: 'var(--color-grey-0)!important',
      option: {
        selectedFocusBackground: 'var(--color-primary-100)!important',
        selectedFocusColor: 'var(--color-primary-600)!important',
        selectedBackground: 'var(--color-primary-50)!important',
        selectedColor: 'var(--color-primary-600)!important',
      },
    },

    // Input Components
    inputtext: {
      borderRadius: '12px!important',
      paddingY: '12px!important',
      paddingX: '16px!important',
      placeholderColor: 'var(--color-grey-300)!important',
      disabledBackground: 'var(--color-grey-50)!important',
      focus: {
        borderColor: 'var(--color-primary-600)!important',
      },
      invalid: {
        placeholderColor: 'var(--color-grey-300)!important',
        borderColor: 'var(--color-red-500)!important',
      },
      sm: {
        fontSize: 'var(--text-small)!important',
      },
    },
    
    // DatePicker Components
    datepicker: {
      panel: {
        background: 'white!important',
        color: 'var(--color-grey-950)!important',
      },
      header: {
        background: 'white!important',
        color: 'var(--color-grey-950)!important',
        borderColor: 'var(--color-grey-100)!important',
      },
      date: {
        color: 'var(--color-grey-950)!important',
        hoverBackground: 'var(--color-primary-50)!important',
        hoverColor: 'var(--color-primary-600)!important',
        selectedBackground: 'var(--color-primary-600)!important',
        selectedColor: 'white!important',
        rangeSelectedBackground: 'var(--color-primary-50)!important',
        rangeSelectedColor: 'var(--color-grey-950)!important',
      },
      today: {
        background: 'transparent!important',
        color: 'var(--color-primary-600)!important',
      },
      dropdown: {
        color: 'white!important',
      },
    },

    // Select Components
    select: {
      borderRadius: '12px!important',
      placeholderColor: 'var(--color-grey-300)!important',
      emptyMessage: {
        padding: '50px!important',
      },
      list: {
        padding: '0px!important',
        gap: '0px!important',
      },
      overlay: {
        padding: '0px!important',
      },
      focus: {
        borderColor: 'var(--color-primary-600)!important',
      },
      option: {
        selectedFocusBackground: 'var(--color-primary-100)!important',
        selectedFocusColor: 'var(--color-primary-600)!important',
        selectedBackground: 'var(--color-primary-50)!important',
        selectedColor: 'var(--color-primary-600)!important',
      },
      invalid: {
        placeholderColor: 'var(--color-grey-300)!important',
      },
      sm: {
        fontSize: 'var(--text-small)!important ',
        paddingY: '12px!important',
      },
    },

    // MultiSelect Components
    multiselect: {
      borderRadius: '12px !important',
      placeholderColor: 'var(--color-grey-300)!important',
      focus: {
        borderColor: 'var(--color-primary-600)!important',
      },
      invalid: {
        placeholderColor: 'var(--color-grey-300)!important',
      },
      option: {
        selectedFocusBackground: 'var(--color-primary-100)!important',
        selectedFocusColor: 'var(--color-primary-600)!important',
        selectedBackground: 'var(--color-primary-50)!important',
        selectedColor: 'var(--color-primary-600)!important',
      },
      sm: {
        fontSize: 'var(--text-small)!important',
        paddingY: '12px!important',
      },
    },

    // Checkbox Components
    checkbox: {
      checked: {
        background: 'var(--color-primary-800)!important',
        hoverBackground: 'var(--color-primary-600)!important',
        borderColor: 'var(--color-primary-600)!important',
      },
    },

    // RadioButton Components
    radiobutton: {
      borderRadius: '50%!important',
      size: '1.25rem!important',
      checked: {
        background: 'var(--color-primary-600)!important',
        hoverBackground: 'var(--color-primary-600)!important',
        borderColor: 'var(--color-primary-600)!important',
      },
      icon: {
        size: '0.5rem!important',
        checkedColor: 'var(--color-grey-0)!important',
      },
    },

    // Message Components
    // Message Components
    message: {
      text: {
        fontWeight: '400!important',
        sm: {
          fontSize: 'var(--text-caption)!important',
        },
      },
    },



    // Float Label Components
    floatlabel: {
      color: 'var(--color-grey-400)!important',
      active: {
        color: 'var(--color-grey-950)!important',
      },
      invalid: {
        color: 'var(--color-red-500)!important',
      },
    },
  },
} as any);
